// Feiertags-Grafiken – nur noch innerhalb des dedizierten HolidayBanners.
// Alle Elemente sind pointer-events:none und respektieren prefers-reduced-motion.

const seeded = (n, seed = 1) =>
  Array.from({ length: n }, (_, i) => {
    const s = Math.sin((i + 1) * seed) * 10000;
    return s - Math.floor(s);
  });

/* ---------- Weihnachten: Sterne + Tannen + Schneerieseln ---------- */
export function SnowFall() {
  const rs = seeded(40, 3);
  return (
    <>
      {/* Tannen links + rechts */}
      {[{ left: "6%" }, { right: "6%" }].map((pos, k) => (
        <svg key={k} width="18" height="24" viewBox="0 0 18 24" className="absolute top-1/2 -translate-y-1/2 hidden sm:block" style={pos}>
          <polygon points="9,1 15,10 12,10 17,17 12,17 18,23 0,23 6,17 1,17 6,10 3,10" fill="#0F6B3B" />
          <rect x="7.5" y="23" width="3" height="1.5" fill="#5B3A1E" />
          <circle cx="4.5" cy="14" r="0.9" fill="#FFD24A" />
          <circle cx="13" cy="15" r="0.9" fill="#DD0000" />
          <polygon points="9,0.5 9.6,2 11,2.2 10,3.1 10.3,4.5 9,3.8 7.7,4.5 8,3.1 7,2.2 8.4,2" fill="#FFD24A" />
        </svg>
      ))}
      {/* Sterne */}
      {[15, 30, 45, 60, 75, 90].map((left, i) => (
        <svg key={i} width="9" height="9" viewBox="0 0 10 10" className="absolute" style={{ top: 4 + (i % 2) * 24, left: `${left}%`, animation: `hamm-twinkle 3.4s ease-in-out ${i * 0.4}s infinite`, fill: "#FFD24A", opacity: 0.9 }}>
          <polygon points="5,0 6,3.6 9.8,3.6 6.7,5.9 7.9,9.5 5,7.3 2.1,9.5 3.3,5.9 0.2,3.6 4,3.6" />
        </svg>
      ))}
      {/* Schneeflocken */}
      {Array.from({ length: 24 }).map((_, i) => {
        const left = rs[i] * 100;
        const size = 2 + rs[i + 24] * 3;
        const dur = 6 + rs[(i + 12) % 40] * 4;
        const delay = -rs[i] * dur;
        return (
          <span key={i} style={{
            position: "absolute", top: -6, left: `${left}%`, width: size, height: size, borderRadius: "50%",
            background: "rgba(255,255,255,0.9)", filter: "blur(0.3px)",
            animation: `hamm-snow-fall ${dur}s linear ${delay}s infinite`,
          }} />
        );
      })}
      <style>{`
        @keyframes hamm-snow-fall { 0% { transform: translate3d(0,-8px,0); opacity: 0; } 15% { opacity: .9; } 100% { transform: translate3d(6px, 60px, 0); opacity: 0; } }
        @keyframes hamm-twinkle { 0%,100% { transform: scale(1); opacity: .6;} 50% { transform: scale(1.35); opacity: 1;} }
      `}</style>
    </>
  );
}

/* ---------- Ostern: Ostereier ---------- */
export function EasterEggs() {
  const eggs = [
    { left: "6%",  fill: "#F4E7C5", stroke: "#00AAA0", pattern: "stripes", delay: 0 },
    { left: "18%", fill: "#FFE1EC", stroke: "#E4477F", pattern: "dots",    delay: 0.4 },
    { left: "82%", fill: "#EAF3FF", stroke: "#2C57D2", pattern: "dots",    delay: 0.8 },
    { left: "94%", fill: "#E8FCEB", stroke: "#0F6B3B", pattern: "stripes", delay: 1.2 },
  ];
  return (
    <>
      {eggs.map((e, i) => (
        <svg key={i} width="16" height="20" viewBox="0 0 14 18" className="absolute top-1/2 -translate-y-1/2 hidden sm:block"
          style={{ left: e.left, transform: "translate(-50%, -50%)", animation: `hamm-egg-wobble 5s ease-in-out ${e.delay}s infinite`, filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.15))" }}>
          <ellipse cx="7" cy="9" rx="6" ry="8.5" fill={e.fill} stroke={e.stroke} strokeWidth="0.9" />
          {e.pattern === "stripes" ? (
            <path d="M1 6 Q4 4 7 6 T13 6 M1 12 Q4 10 7 12 T13 12" fill="none" stroke={e.stroke} strokeWidth="0.7" />
          ) : (
            <>
              <circle cx="5" cy="7" r="0.9" fill={e.stroke} />
              <circle cx="9" cy="6" r="0.9" fill={e.stroke} />
              <circle cx="7" cy="11" r="0.9" fill={e.stroke} />
            </>
          )}
        </svg>
      ))}
      <style>{`@keyframes hamm-egg-wobble { 0%,100% { transform: translate(-50%,-50%) rotate(-6deg);} 50% { transform: translate(-50%,-58%) rotate(6deg);} }`}</style>
    </>
  );
}

/* ---------- Silvester: Feuerwerks-Bursts ---------- */
export function Fireworks() {
  const bursts = [
    { left: "8%",  color: "#FFD24A", delay: 0 },
    { left: "26%", color: "#00AAA0", delay: 0.7 },
    { left: "50%", color: "#E4477F", delay: 1.4 },
    { left: "74%", color: "#FFD24A", delay: 0.4 },
    { left: "92%", color: "#00AAA0", delay: 1.0 },
  ];
  return (
    <>
      {bursts.map((b, i) => (
        <div key={i} className="absolute top-1/2 -translate-y-1/2" style={{ left: b.left, animation: `hamm-burst 2.4s ease-out ${b.delay}s infinite` }}>
          {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
            <span key={a} style={{
              position: "absolute", width: 8, height: 1.5, background: b.color,
              transform: `rotate(${a}deg) translateX(6px)`, transformOrigin: "0 50%",
              borderRadius: 2, boxShadow: `0 0 6px ${b.color}`,
            }} />
          ))}
          <span style={{ position: "absolute", left: -2, top: -2, width: 4, height: 4, borderRadius: "50%", background: b.color, boxShadow: `0 0 10px ${b.color}` }} />
        </div>
      ))}
      <style>{`@keyframes hamm-burst { 0% { transform: translateY(-50%) scale(0); opacity: 0;} 30% { opacity: 1; transform: translateY(-50%) scale(1);} 100% { transform: translateY(-50%) scale(1.6); opacity: 0;} }`}</style>
    </>
  );
}

/* ---------- Tag der Deutschen Einheit: Schwarz-Rot-Gold Streifen ---------- */
export function GermanFlag() {
  return (
    <>
      <div className="absolute inset-x-0 top-0 flex h-[3px]">
        <div className="flex-1 bg-black" />
        <div className="flex-1 bg-[#DD0000]" />
        <div className="flex-1 bg-[#FFCE00]" />
      </div>
      <div className="absolute inset-x-0 bottom-0 flex h-[3px]">
        <div className="flex-1 bg-black" />
        <div className="flex-1 bg-[#DD0000]" />
        <div className="flex-1 bg-[#FFCE00]" />
      </div>
    </>
  );
}

/* ---------- Black Friday: Sweep ---------- */
export function BlackFridaySweep() {
  return (
    <>
      <span className="absolute inset-y-0 -left-1/3 w-1/3" style={{
        background: "linear-gradient(90deg, transparent, rgba(255,210,74,0.35), transparent)",
        animation: "hamm-sweep 4.5s linear infinite",
      }} />
      <style>{`@keyframes hamm-sweep { 0% { transform: translateX(0);} 100% { transform: translateX(500%);} }`}</style>
    </>
  );
}

/* ---------- Weltfrauentag: Blumenstrauß-Paar + fallende Blüten ---------- */
export function Blossoms() {
  const rs = seeded(10, 11);
  return (
    <>
      {[{ left: "5%" }, { right: "5%" }].map((pos, k) => (
        <svg key={k} width="30" height="36" viewBox="0 0 34 42" className="absolute top-1/2 -translate-y-1/2 hidden sm:block" style={pos}>
          <path d="M17 42 Q15 30 12 20" stroke="#0F6B3B" strokeWidth="1.4" fill="none" />
          <path d="M17 42 Q17 30 17 18" stroke="#0F6B3B" strokeWidth="1.4" fill="none" />
          <path d="M17 42 Q19 30 22 20" stroke="#0F6B3B" strokeWidth="1.4" fill="none" />
          <ellipse cx="14" cy="30" rx="3" ry="1.2" fill="#4CA36B" transform="rotate(-30 14 30)" />
          <ellipse cx="20" cy="32" rx="3" ry="1.2" fill="#4CA36B" transform="rotate(30 20 32)" />
          {[[12, 16, "#FFFFFF"], [17, 12, "#FFE1EC"], [22, 16, "#FFFFFF"]].map(([cx, cy, color], i) => (
            <g key={i} style={{ transformOrigin: `${cx}px ${cy}px`, animation: `hamm-bloom 3.6s ease-in-out ${i * 0.4}s infinite` }}>
              {[0, 72, 144, 216, 288].map((a) => (
                <ellipse key={a} cx={cx} cy={cy - 3.2} rx="1.6" ry="3.2" fill={color} opacity="0.95" transform={`rotate(${a} ${cx} ${cy})`} />
              ))}
              <circle cx={cx} cy={cy} r="1.2" fill="#FFD24A" />
            </g>
          ))}
          <path d="M13 34 Q17 32 21 34 L21 37 Q17 35 13 37 Z" fill="#FFFFFF" opacity="0.9" />
        </svg>
      ))}
      {rs.slice(0, 8).map((r, i) => (
        <svg key={`b-${i}`} width="10" height="10" viewBox="0 0 10 10" className="absolute" style={{
          top: -6, left: `${8 + r * 84}%`,
          animation: `hamm-petal 8s linear ${-r * 6}s infinite`,
        }}>
          {[0, 72, 144, 216, 288].map((a) => (
            <ellipse key={a} cx="5" cy="2" rx="1.2" ry="2.2" fill="#FFFFFF" opacity="0.85" transform={`rotate(${a} 5 5)`} />
          ))}
        </svg>
      ))}
      <style>{`
        @keyframes hamm-bloom { 0%,100% { transform: scale(1);} 50% { transform: scale(1.15);} }
        @keyframes hamm-petal { 0% { transform: translate3d(0,-8px,0) rotate(0);} 100% { transform: translate3d(-14px, 60px, 0) rotate(180deg);} }
      `}</style>
    </>
  );
}

/* ---------- Valentinstag: Herzen ---------- */
export function Hearts() {
  const anchors = [
    { left: "8%",  size: 14, delay: 0 },
    { left: "22%", size: 11, delay: 0.4 },
    { left: "38%", size: 12, delay: 0.8 },
    { left: "62%", size: 12, delay: 1.1 },
    { left: "78%", size: 11, delay: 0.6 },
    { left: "92%", size: 14, delay: 1.3 },
  ];
  return (
    <>
      {anchors.map((a, i) => (
        <svg key={i} width={a.size} height={a.size} viewBox="0 0 24 24" className="absolute top-1/2 -translate-y-1/2"
          style={{ left: a.left, fill: "#FFFFFF",
                   animation: `hamm-heart 3.4s ease-in-out ${a.delay}s infinite`,
                   filter: "drop-shadow(0 1px 2px rgba(228,71,127,0.5))" }}>
          <path d="M12 21s-7-4.35-9.5-9C.9 8.3 3 4.5 6.5 4.5c2 0 3.5 1 5.5 3 2-2 3.5-3 5.5-3 3.5 0 5.6 3.8 4 7.5C19 16.65 12 21 12 21z"/>
        </svg>
      ))}
      <style>{`@keyframes hamm-heart { 0%,100% { transform: translateY(-50%) scale(1);} 30% { transform: translateY(-50%) scale(1.28);} 60% { transform: translateY(-50%) scale(0.95);} }`}</style>
    </>
  );
}

export const HOLIDAY_ANIMATIONS = {
  weihnachten: SnowFall,
  ostern: EasterEggs,
  silvester: Fireworks,
  tag_der_deutschen_einheit: GermanFlag,
  black_friday: BlackFridaySweep,
  weltfrauentag: Blossoms,
  valentinstag: Hearts,
};
